/*
 * 613 — estimated ship date + Same-day Upgrade toggle. Shared by
 * snippets/ship-estimate-613.liquid (PDP) and snippets/cart-ship-estimate-613.liquid
 * (cart page + drawer). Spec: staging-plan/SAME-DAY-RUSH-SPEC.md (D10, D13, D14, D15).
 *
 * Same rules as the "Scheduled ship date" Flow (Shopify-Order-Flow/flow/scheduled-ship-date):
 * a line ships N business days after its start day; start = today if a business day and
 * before the cutoff, else the next business day; cutoff 3 PM ET, or 12 PM ET for same-day
 * lines (N = 0) unless the Same-day Upgrade is in the cart. The order ships on its latest line.
 *
 * Markup contract ([data-ship-est] element):
 *   data-mode="pdp" | "cart" | "card"
 *   data-days="0,2"           turnaround of each line (PDP: one value)
 *   data-closed='["2026-11-26"]'
 *   data-rush-variant / data-rush-price   only when the upgrade can be offered
 *   data-rush-in-cart="1"     cart: the upgrade is already in the cart
 *   data-rush-remove="<id>"   cart: the upgrade is in the cart but the cart doesn't qualify → removed
 *   data-cm-products="123,456" data-cm-shop data-cm-api   cart: Corporate Merch lines, whose
 *                             date comes from the Corporate Merch app's estimated-ship-date API
 * PDP children: [data-ship-est-date], [data-ship-est-line], [data-ship-est-rush],
 *               [data-ship-est-rush-input], [data-ship-est-rush-price], [data-ship-est-left]
 * Card (snippets/card-ship-613.liquid, same-day products on collection cards): the element itself
 *   gets "Ships today" / "Ships tomorrow" / "Ships Monday" (no rush assumed).
 * Cart (the data element renders nothing; it drives elements in sections/main-cart.liquid):
 *   [data-ship-est-cart-date]  span under the Order Summary heading
 *   [data-ship-est-cart-rush]  optional line under the products (input, price, left)
 */
(function () {
  if (window.ShipEst613) {
    window.ShipEst613.scan();
    return;
  }

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var cartRushQty = null; // quantity of the upgrade in the cart, once known
  var api_;
  var continueUntil = 0;   // Check out clicks pass the prompt until then (ms)
  var cmDates = {};        // Corporate Merch product id -> 'YYYY-MM-DD' | false (failed) | 'pending'

  function loadCmDate(api, shop, productId) {
    if (cmDates[productId] !== undefined) return;
    cmDates[productId] = 'pending';
    var url = api.replace(/\/$/, '') + '/api/estimated-ship-date' + String.fromCharCode(63) +
      'shop=' + encodeURIComponent(shop) + '&shopify_product_id=' + encodeURIComponent(productId);
    fetch(url, { headers: { Accept: 'application/json' }, credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (p) {
        var iso = (p && (p.estimated_ship_date || (p.data && (p.data.estimated_ship_date || (p.data.data && p.data.data.estimated_ship_date))))) || '';
        // The API returns ET with an offset (2026-10-20T19:39:09-04:00), so the date part is the ET date.
        cmDates[productId] = /^\d{4}-\d{2}-\d{2}/.test(iso) ? iso.slice(0, 10) : false;
      })
      .catch(function () { cmDates[productId] = false; })
      .finally(function () { api_.scan(); });
  }

  function easternNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { date: parts.year + '-' + parts.month + '-' + parts.day, minutes: (+parts.hour % 24) * 60 + +parts.minute };
  }
  function addDays(d, n) {
    var t = new Date(d + 'T12:00:00Z');
    t.setUTCDate(t.getUTCDate() + n);
    return t.toISOString().slice(0, 10);
  }
  function ordinal(n) {
    var s = ['th', 'st', 'nd', 'rd'], v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }
  function longDate(d) {
    var t = new Date(d + 'T12:00:00Z');
    return WEEKDAYS[t.getUTCDay()] + ', ' + MONTHS[t.getUTCMonth()] + ' ' + ordinal(t.getUTCDate());
  }
  function countdown(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    return h ? h + 'h ' + m + 'm' : m + 'm';
  }

  // Latest ship date across the given turnarounds, plus the countdown for the line that sets it.
  function estimate(daysList, closed, now, hasRush) {
    function isBusinessDay(d) {
      var wd = new Date(d + 'T12:00:00Z').getUTCDay();
      return wd !== 0 && wd !== 6 && closed.indexOf(d) === -1;
    }
    function nextBusinessDay(d) {
      var n = addDays(d, 1);
      while (!isBusinessDay(n)) n = addDays(n, 1);
      return n;
    }
    var open = isBusinessDay(now.date);
    var best = null;
    daysList.forEach(function (days) {
      var cutoff = days === 0 && !hasRush ? 12 * 60 : 15 * 60;
      var beforeCutoff = open && now.minutes < cutoff;
      var day = beforeCutoff ? now.date : nextBusinessDay(now.date);
      for (var i = 0; i < days; i++) day = nextBusinessDay(day);
      var left = beforeCutoff ? cutoff - now.minutes : null;
      if (!best || day > best.shipDate || (day === best.shipDate && left !== null && (best.minutesLeft === null || left < best.minutesLeft))) {
        best = { shipDate: day, minutesLeft: left };
      }
    });
    var rushWindow = open && now.minutes >= 12 * 60 && now.minutes < 15 * 60;
    return {
      shipDate: best ? best.shipDate : nextBusinessDay(now.date),
      minutesLeft: best ? best.minutesLeft : null,
      rushMinutesLeft: rushWindow ? 15 * 60 - now.minutes : null
    };
  }

  function readDays(el) {
    var list = String(el.getAttribute('data-days') || '').split(',').map(function (v) { return parseInt(v, 10); })
      .filter(function (v) { return v >= 0; });
    return list.length ? list : [1];
  }

  function renderCart(el) {
    dropIneligibleRush(el);
    var dateEl = document.querySelector('[data-ship-est-cart-date]');
    var row = document.querySelector('[data-ship-est-cart-rush]');
    var daysAttr = el.getAttribute('data-days');
    var daysList = daysAttr ? readDays(el) : [];
    var closed = [];
    try { closed = JSON.parse(el.getAttribute('data-closed') || '[]'); } catch (e) { closed = []; }
    var now = easternNow();
    var inCart = cartRushQty !== null ? cartRushQty > 0 : el.getAttribute('data-rush-in-cart') === '1';
    var sameDayOnly = daysList.length > 0 && daysList.every(function (d) { return d === 0; });

    // Corporate Merch lines: their date comes from the app's API (same as its PDP block).
    var cmIds = String(el.getAttribute('data-cm-products') || '').split(',').filter(Boolean);
    var cmApi = el.getAttribute('data-cm-api'), cmShop = el.getAttribute('data-cm-shop');
    var cmLatest = null, cmPending = false, cmFailed = false;
    cmIds.forEach(function (id) {
      if (cmApi && cmShop) loadCmDate(cmApi, cmShop, id);
      var d = cmDates[id];
      if (d === 'pending' || d === undefined) cmPending = true;
      else if (d === false) cmFailed = true;
      else if (!cmLatest || d > cmLatest) cmLatest = d;
    });

    var est = estimate(daysList.length ? daysList : [], closed, now, inCart && sameDayOnly);
    var offerRush = est.rushMinutesLeft !== null && el.hasAttribute('data-rush-variant') && sameDayOnly && !cmIds.length;
    var shipDate = daysList.length ? est.shipDate : null;
    if (cmLatest && (!shipDate || cmLatest > shipDate)) shipDate = cmLatest;

    if (dateEl) {
      var show = !!shipDate && !cmPending && !cmFailed;
      dateEl.hidden = !show;
      if (show) dateEl.textContent = 'Estimated ship date: ' + (shipDate === now.date ? 'Today' : longDate(shipDate));
    }

    if (row) {
      row.hidden = !offerRush;
      if (offerRush) {
        row.querySelector('[data-ship-est-rush-price]').textContent = el.getAttribute('data-rush-price');
        row.querySelector('[data-ship-est-left]').textContent = 'Order in ' + countdown(est.rushMinutesLeft) + ' (by 3 PM ET)';
        row.querySelector('[data-ship-est-rush-input]').checked = inCart;
      }
    }

    // While the optional line is showing, it stands in for the upgrade's own cart line.
    var rushId = el.getAttribute('data-rush-variant');
    document.querySelectorAll('.cart-item[data-variant-id]').forEach(function (item) {
      item.classList.toggle('cart-613-rush-line', !!rushId && offerRush && item.getAttribute('data-variant-id') === rushId);
    });
  }

  function renderCard(el) {
    var closed = [];
    try { closed = JSON.parse(el.getAttribute('data-closed') || '[]'); } catch (e) { closed = []; }
    var now = easternNow();
    var ship = estimate(readDays(el), closed, now, false).shipDate;
    var when = ship === now.date ? 'today'
      : ship === addDays(now.date, 1) ? 'tomorrow'
      : WEEKDAYS[new Date(ship + 'T12:00:00Z').getUTCDay()];
    el.textContent = 'Ships ' + when;
    el.hidden = false;
  }

  function render(el) {
    var mode = el.getAttribute('data-mode') || 'pdp';
    if (mode === 'cart') { renderCart(el); return; }
    if (mode === 'card') { renderCard(el); return; }
    var daysList = readDays(el);
    var closed = [];
    try { closed = JSON.parse(el.getAttribute('data-closed') || '[]'); } catch (e) { closed = []; }
    var now = easternNow();

    var inCart = cartRushQty !== null ? cartRushQty > 0 : el.getAttribute('data-rush-in-cart') === '1';
    var sameDayOnly = daysList.every(function (d) { return d === 0; });
    var est = estimate(daysList, closed, now, mode === 'cart' && inCart && sameDayOnly);
    var offerRush = est.rushMinutesLeft !== null && el.hasAttribute('data-rush-variant') && sameDayOnly;

    var dateEl = el.querySelector('[data-ship-est-date]');
    var line = el.querySelector('[data-ship-est-line]');
    var rush = el.querySelector('[data-ship-est-rush]');

    if (offerRush) {
      el.querySelector('[data-ship-est-rush-price]').textContent = el.getAttribute('data-rush-price');
      el.querySelector('[data-ship-est-left]').textContent = '· ' + countdown(est.rushMinutesLeft) + ' left';
      el.querySelector('[data-ship-est-rush-input]').checked = inCart;
    }

    var when = est.shipDate === now.date ? 'today' : longDate(est.shipDate);
    if (est.minutesLeft !== null && !(offerRush && inCart)) {
      line.innerHTML = 'Order in <strong>' + countdown(est.minutesLeft) + '</strong> to ship ' + when;
    } else {
      line.textContent = 'Ships ' + when;
    }

    rush.hidden = !offerRush;
    // PDP: during the rush window the checkbox replaces the date (Cat, D14). Cart: both show.
    dateEl.hidden = mode === 'pdp' && offerRush;
  }

  function rushVariantId() {
    var el = document.querySelector('[data-ship-est][data-rush-variant]');
    if (el) return Number(el.getAttribute('data-rush-variant'));
    el = document.querySelector('[data-ship-est][data-rush-remove]');
    return el ? Number(el.getAttribute('data-rush-remove')) : null;
  }

  // Cart: the upgrade is in a cart that no longer qualifies (D1). Take it out and say why, so it
  // never sits there as a stray $4.99 line the checkout rule would reject.
  var removingRush = false;
  function dropIneligibleRush(el) {
    if (removingRush || !el.hasAttribute('data-rush-remove')) return;
    removingRush = true;
    setRush(false)
      .then(function () {
        var errors = document.getElementById('cart-errors');
        if (errors) errors.textContent = 'Same-day upgrade removed. It\u2019s only available when everything in your cart ships same day.';
      }, function () {})
      .finally(function () { removingRush = false; });
  }

  function cartRoot() {
    return (window.routes && routes.cart_url) ? routes.cart_url.replace(/\/cart$/, '') : '';
  }

  function syncFromCart() {
    var id = rushVariantId();
    if (!id) return;
    fetch(cartRoot() + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartRushQty = 0;
        cart.items.forEach(function (item) { if (item.variant_id === id) cartRushQty += item.quantity; });
        api.scan();
      })
      .catch(function () {});
  }

  // The sections to re-render after the toggle: the same ones the theme's cart.js and
  // cart-drawer.js use, limited to what's on the page.
  function sectionsOnPage() {
    var list = [{ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var shipping = document.getElementById('main-cart-shipping');
    if (items && items.dataset.id) list.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    if (footer && footer.dataset.id) list.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents-2' });
    if (shipping && shipping.dataset.id) list.push({ id: 'main-cart-shipping', section: shipping.dataset.id, selector: '.js-contents-shipping' });
    if (document.getElementById('CartDrawer')) list.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer', own: true });
    return list;
  }

  function applySections(list, sections) {
    if (!sections) return;
    list.forEach(function (s) {
      var html = sections[s.section];
      var host = document.getElementById(s.id);
      if (!html || !host) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector(s.selector);
      var target = s.own || s.selector === '.shopify-section' ? host : host.querySelector(s.selector);
      if (src && target) target.innerHTML = src.innerHTML;
    });
  }

  function setRush(want) {
    var id = rushVariantId();
    if (!id) return Promise.reject();
    if (want && cartRushQty > 0) return Promise.resolve();
    var list = sectionsOnPage();
    var sections = list.map(function (s) { return s.section; }).join(',');
    var url = cartRoot() + (want ? '/cart/add.js' : '/cart/change.js');
    var body = want
      ? { items: [{ id: id, quantity: 1 }], sections: sections, sections_url: window.location.pathname }
      : { id: String(id), quantity: 0, sections: sections, sections_url: window.location.pathname };
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (json) { if (!r.ok || json.status) throw json; return json; }); })
      .then(function (state) {
        cartRushQty = want ? 1 : 0;
        applySections(list, state.sections);
        var cartItems = document.querySelector('cart-items');
        if (cartItems) {
          // Cart page: the sections above are already fresh. Don't publish cartUpdate here: the
          // theme's <cart-items> answers it by re-rendering the whole list, which drops the DRIP
          // "Edit" link (raw URL shows) and leaves the free-shipping bar blank. Redraw the bar the
          // way the theme does after a quantity change instead.
          if (typeof cartItems.cartShipping === 'function' && document.querySelector('.cart-shipping')) {
            try { cartItems.cartShipping(); } catch (e) {}
          }
        } else if (window.publish && window.PUB_SUB_EVENTS) {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ship-est-613' }); } catch (e) {}
        }
        api.scan();
      });
  }

  function onToggle(input) {
    var label = input.closest('[data-ship-est-rush], [data-ship-est-cart-rush]');
    var want = input.checked;
    label.setAttribute('aria-busy', 'true');
    setRush(want)
      .catch(function () { input.checked = !want; })
      .finally(function () { label.removeAttribute('aria-busy'); });
  }

  // ── Prompt on Check out (cart page + drawer) ─────────────────────────────

  function openPrompt(button, dataEl, offerEl) {
    var dialog = document.getElementById('ShipEst613-Prompt');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.id = 'ShipEst613-Prompt';
      dialog.className = 'ship-est-613-prompt';
      dialog.innerHTML =
        '<p class="ship-est-613-prompt__title">⚡ Need it today?</p>' +
        '<p class="ship-est-613-prompt__text">Add same-day shipping for <strong data-prompt-price></strong> and your order ships today. <span data-prompt-left></span></p>' +
        '<div class="ship-est-613-prompt__actions">' +
        '<button type="button" class="button button--primary" data-prompt-yes><span class="button-label">Add it and check out</span></button>' +
        '<button type="button" class="button button--simple" data-prompt-no><span class="button-label">No thanks</span></button>' +
        '</div>';
      document.body.appendChild(dialog);
    }
    var left = easternNow();
    dialog.querySelector('[data-prompt-price]').textContent = dataEl.getAttribute('data-rush-price');
    dialog.querySelector('[data-prompt-left]').textContent = countdown(15 * 60 - left.minutes) + ' left to order.';

    function proceed() {
      dialog.close();
      // Adding the upgrade re-renders the cart footer, which replaces the Check out button, so
      // the one that was clicked may be detached by now. Click the live one.
      var target = button.isConnected ? button : document.querySelector('button[name="checkout"]');
      if (!target) { window.location.href = cartRoot() + '/checkout'; return; }
      // Let Check out clicks through for a few seconds, not just once: ReConvert's checkout gate
      // holds the click and re-clicks the button itself, and a one-shot pass reopened the prompt.
      continueUntil = Date.now() + 5000;
      target.click();
    }
    dialog.querySelector('[data-prompt-yes]').onclick = function () {
      this.setAttribute('aria-busy', 'true');
      setRush(true).then(proceed, proceed);
    };
    dialog.querySelector('[data-prompt-no]').onclick = proceed;
    dialog.onclick = function (e) { if (e.target === dialog) proceed(); };
    dialog.showModal();
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!button) return;
    if (Date.now() < continueUntil) return;
    // Shows on every Check out click while the upgrade isn't ticked (Cat, 2026-10-15; was once per session).
    var offer = document.querySelector('[data-ship-est-cart-rush]:not([hidden])');
    var data = document.querySelector('[data-ship-est][data-mode="cart"]');
    if (!offer || !data || offer.querySelector('[data-ship-est-rush-input]').checked) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openPrompt(button, data, offer);
  }, true);

  var api = api_ = {
    scan: function () {
      document.querySelectorAll('[data-ship-est]').forEach(render);
    },
    estimate: estimate
  };
  window.ShipEst613 = api;

  // Capture phase + stopPropagation: the cart row sits inside the theme's <cart-items>, which
  // treats any input change as a quantity edit (POST /cart/change → 400 → "There was an error
  // while updating your cart"). On the PDP it keeps the toggle away from the product form too.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-ship-est-rush-input]')) {
      e.stopPropagation();
      onToggle(e.target);
    }
  }, true);
  // Keep the checkbox honest if the upgrade is removed in the cart or drawer.
  document.addEventListener('cart:change', syncFromCart);
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'ship-est-613') syncFromCart(); }); } catch (e) {}
  }

  api.scan();
  syncFromCart();
  setInterval(api.scan, 30000);
  // Quick View, cart re-renders and the drawer inject new [data-ship-est] elements.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var n = records[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-ship-est]') || n.querySelector('[data-ship-est]'))) { api.scan(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
